import { Appointment } from "@/features/appointments/types/Appointment";
import { useConsultsStore } from "@/utils/stores/useConsultsStore";
import { ExpertRole } from "../types/ExpertRole";

export const useSpecialistConsult = (): { shouldPushBooking: boolean; hasFutureSpecialistAppointment: boolean, specConsultsLeft: Appointment[], lastSpecialistConsult: Appointment } => {
    const { consultsData } = useConsultsStore();
    const futureSpecialistConsults = consultsData?.specialistFutureConsults || [];
    const pastConsults = consultsData?.allPastAppointments || [];
    const specConsultsLeft = consultsData.specialistFutureConsults || []

    const hasFutureSpecialistAppointment = futureSpecialistConsults.length > 0;

    const sortedPastConsults = pastConsults.length > 0 ? pastConsults
        .filter(consult => (consult.expert.role === ExpertRole.Specialist || consult.expert.role === ExpertRole.Physician))
        .sort((a, b) => new Date(b.date).getTime() - new Date(a.date).getTime()) : [];

    const lastSpecialistConsult = sortedPastConsults[0];

    const lastConsultWithin60Days = lastSpecialistConsult && lastSpecialistConsult.remainingDays >= -60;

    const shouldPushBooking = !hasFutureSpecialistAppointment && !lastConsultWithin60Days;

    return { shouldPushBooking, hasFutureSpecialistAppointment, specConsultsLeft, lastSpecialistConsult }
}